module.exports = __webpack_public_path__ + "static/media/MobileApp.524c91d9.png";